// extracted by mini-css-extract-plugin
module.exports = {"listItem":"list__listItem___1B44s"};